import styled from 'styled-components/macro';

export const Wrapper = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
`;
